import { render, staticRenderFns } from "./AddOrUpdateFreight.vue?vue&type=template&id=da001674&scoped=true"
import script from "./AddOrUpdateFreight.vue?vue&type=script&lang=js"
export * from "./AddOrUpdateFreight.vue?vue&type=script&lang=js"
import style0 from "./AddOrUpdateFreight.vue?vue&type=style&index=0&id=da001674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da001674",
  null
  
)

export default component.exports